import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_img = _resolveComponent("b-img")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_img, {
      src: require('/src/assets/seating.jpg'),
      "fluid-grow": "",
      alt: "People in a seating image"
    }, null, 8, ["src"])
  ]))
}